import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';

if (environment.production) {
  enableProdMode();
  // Sentry.init({
  //   dsn: 'https://e2fd41bfd4d809c2ef3a2217e243c55f@o4507804268494848.ingest.de.sentry.io/4507804284158032',
  //   integrations: [
  //     Sentry.browserTracingIntegration(),
  //     Sentry.replayIntegration({
  //       blockAllMedia: false,
  //       unblock: ['svg'],
  //       block: ['img', 'video', 'object', 'picture', 'embed', 'map', 'audio'],
  //     }),
  //   ],
  //   // Tracing
  //   tracesSampleRate: 1.0, //  Capture 100% of the transactions
  //   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  //   tracePropagationTargets: [
  //     'localhost',
  //     environment.base,
  //     environment.graphql,
  //     environment.api,
  //   ],
  //   // Session Replay
  //   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  //   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  //   environment: environment.production ? 'production' : 'develop',
  // });
}

function bootstrap() {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
